import React, {useEffect, useRef, useState} from 'react';
import './FormCustom.module.css'
import styles from "./app.module.css"
import MainMenu from "./MainMenu/MainMenu";
import Header from "./Header/Header";
import SecondMenu from "./SecondMenu/SecondMenu";
import Slider from "./Slider/Slider";
import ModalWindow from "./FormTemplate/ModalWindow/ModalWindow";
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import LoginForm from "./Auth/LoginForm/LoginForm";
import RegionChange from "./RegionChange/RegionChange";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setDomainPreference, setMobileMode, setShowStickedMenu} from "./Reducer/GlobalReducer";
import Lk from "./LK/LK";
import FullCard from "./Slider/FullCard";
import OrderSimCard from "./OrderSimCard/OrderSimCard";
import {BiWebcam} from "react-icons/bi";
import SimPersonalData from "./SimRegistrator/PersonalData/SimPersonalData";
import SimSelfRegister from "./SimRegistrator/SimSelfRegister";
import InputItem from "./FormTemplate/InputItem/InputItem";
import GroupDataItem from "./FormTemplate/GroupDataItem/GroupDataItem";
import Footer from "./Footer/Footer";
import DeliveryItem from "./OrderSimCard/DeliveryItem/DeliveryItem";
import RestorePass from "./Auth/RestorePass/RestorePass";
import AcceptCookie from "./FormTemplate/AcceptCookie/AcceptCookie";
import MenuDelivery from "./MainMenu/Delivery/MenuDelivery";
import MenuPayment from "./MainMenu/Payment/MenuPayment";
import MenuWarranty from "./MainMenu/Warranty/MenuWarranty";
import MenuMNP from "./MainMenu/MNP/MenuMNP";
import MenuActivate from "./MainMenu/Activate/MenuActivate";
import Switcher from "./Switcher/Switcher";
import SellStage from "./SellStage/SellStage";
import MenuContact from "./MainMenu/Contact/MenuContact";
import MenuChoose from "./MainMenu/Choose/MenuChoose";
import {Helmet} from "react-helmet";
import ThirdLine from "./ThirdLine/ThirdLine";
import ShortCard from "./Slider/ShortCard/ShortCard";
import XFilterPath from "./SecondMenu/XFilterPath/XFilterPath";
import MnpItem from "./Slider/MnpItem/MnpItem";
import PaymentCheck from "./PaymentBank/PaymentCheck";
import useApiQuery from "./ApiQuery/UseApiQuery";
import PrefLoader from "./PrefLoader/PrefLoader";
import {useIsMobile} from "./Util/CheckMobile";
import VKReview from "./FormTemplate/VKReview/VKReview";
import ChoiceBot from "./ChoiceBot/ChoiceBot";
export const AppContext = React.createContext<any | undefined>(undefined);

function App() {
    const [isOpen, setIsOpen] = useState(false);
    const authToken = useSelector((state:ReduxStateInt)  => {return state.authToken})
    const isAdmin = useSelector((state:ReduxStateInt)  => {return state.isAdmin})
    const selectRegion = useSelector((state:ReduxStateInt)  => {return state.baseRegion.makeSelectRegion})
    const dispatch = useDispatch()

    const mobileMode = useSelector((state:ReduxStateInt)  => {return state.mobileMode})
    const showStickedMenu =useSelector((state:ReduxStateInt)  => {return state.showStickedMenu})
    const isMobile = useIsMobile(800)

    const prefUser = useSelector((state:ReduxStateInt)  => {return state.prefUser})
    const prefDomain = useSelector((state:ReduxStateInt)  => {return state.prefDomain})

    const location = useLocation()


    useEffect(()=>{
        if(! location?.pathname) return
        let showStickedMenu = true
        console.log(`current location ${location?.pathname}`)
        const lc = location?.pathname
        if(lc?.match(/^\/order.*/ui)){
            showStickedMenu = false
        }
        if(lc?.match(/^\/lk\/.*/ui)){
            showStickedMenu = false
        }
        if(lc?.match(/^\/tarif\/mnp.*/ui)){
            showStickedMenu = false
        }

        dispatch(setShowStickedMenu(showStickedMenu))


    },[location])

    useEffect(()=>{
        dispatch(setMobileMode(isMobile))

    })


    const mainPage = () =>{
       return(
        <>
            <PrefLoader/>
            <div className={"container-fluid gx-0 " + styles.Wrapper} >
                <Helmet>
                    <title>sim-unlim : Пожалуй лучшие тарифы от операторов</title>
                    <link rel="canonical" href="https://sim-unlim.com" />
                    <meta name="description" content="Лучшие тарифы, безлимитные тарифы, оформление по паспорту" />
                </Helmet>
                <div className={"row-fluid"}>
                    <Header/>
                </div>


                {prefUser?.showMainMenu &&
                    <div className={"row-fluid"}>
                        <MainMenu/>
                    </div>
                }

                {prefUser?.showThirdMenu &&
                    <div className={"row-fluid"}>
                        <ThirdLine></ThirdLine>
                    </div>
                }

                {prefUser?.showSecondMenu &&
                    <div className={"row-fluid"}>
                        <Routes >
                            <Route path='/' element={<SecondMenu/>}/>
                            <Route path='/xfilter/*' element={<XFilterPath/>}/>

                        </Routes>
                    </div>

                }


                <div className={styles.hrFilter}>
                    <hr></hr>
                </div>


                <div className={styles.mainContent}>
                    {selectRegion && <RegionChange />}

                    <div className={"row-fluid"} id={"mainContainer"}>
                        <Routes >
                            <Route path='/ext' element={<Switcher/>} />

                            <Route path='/auth/restore' element={<RestorePass/>} />
                            <Route path='/lk/*' element={<Lk/>} />
                            <Route path='/auth' element={<LoginForm/>} />

                            <Route path='/order' element={<OrderSimCard/>} />

                            <Route path='/menu/delivery' element={<MenuDelivery/>} />
                            <Route path='/menu/payment' element={<MenuPayment/>} />
                            <Route path='/menu/warranty' element={<MenuWarranty/>} />
                            <Route path='/menu/mnp' element={<MenuMNP/>} />
                            <Route path='/menu/activate' element={<MenuActivate/>} />
                            <Route path='/menu/contact' element={<MenuContact/>} />
                            <Route path='/menu/choose' element={<MenuChoose/>} />

                            {prefUser?.showSlider &&
                                <>
                                    <Route path='/' element={<Slider width={"100%"} height={"100%"} autoPlay={false} autoPlayTime={1000}/>}/>
                                    <Route path='/bundle/*' element={<Slider width={"100%"} height={"100%"} autoPlay={false} autoPlayTime={1000}/>}/>
                                </>

                            }


                            <Route path='/tarif/*' element={<FullCard/>}/>
                            <Route path='/tarif/mnp' element={<MnpItem/>}/>


                            <Route path='/short/*' element={<ShortCard/>}/>
                            <Route path='/xfilter/*' element={<Slider width={"100%"} height={"100%"} autoPlay={false} autoPlayTime={1000}/>}/>


                        </Routes>
                    </div>

                    {prefDomain?.showReview &&
                        <div className={"row-fluid justify-content-center align-items-center d-flex"}>
                            <VKReview/>

                        </div>
                    }


                    {prefUser?.showAcceptCookie &&
                        <AcceptCookie></AcceptCookie>

                    }


                </div>

                {prefUser?.showFooter &&
                    <div className={"row-fluid gx-0"}>
                        <Footer/>
                    </div>

                }

                {/* Отступ для меню в мобильной версии */}
                {mobileMode && showStickedMenu &&
                    <div className={"row-fluid gx-0"}>
                        <div className={styles.mbMenuPlace}>
                        </div>
                    </div>

                }



            </div>
        </>
    )
    }


    return (
                <Routes >
                    <Route path='/*' element={mainPage()} />
                    <Route path='/payment/*' element={<PaymentCheck/>}/>
                    <Route path='/bot/choice' element={<ChoiceBot/>}/>
                </Routes>
    );
}

export default App;
